<template>
    <div class="sidebar" id="sidebar" :class="{ collapsed: sidebarCollapsed }">
        <div class="sidebar-links">
            <div v-for="item in sidebarItems.filter((x) => x.visible)" :key="item.name">
                <router-link
                    v-if="!item.dropdown"
                    class="sidebar__item"
                    :to="item.path"
                    :class="$route.name === item.name ? 'active' : ''"
                >
                    <div class="sidebar__item-rec"></div>
                    <img :src="require('@/assets/img/sidebar/' + item.icon)" alt="" />
                    <span class="sidebar__item-text">{{ item.title }}</span>
                </router-link>

                <div v-else class="sidebar__item_dropdown">
                    <div
                        class="sidebar__item sidebar__item_dropdown-header"
                        :class="isSidebarHeaderActive(item) ? 'active' : ''"
                        @click="dropdownController(item.name)"
                    >
                        <div class="sidebar__item-rec"></div>
                        <img :src="require('@/assets/img/sidebar/' + item.icon)" alt="" />
                        <span class="sidebar__item-text">{{ item.title }}</span>
                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1 3L7 9L13 3"
                                stroke="#2E343B"
                                stroke-width="1.2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <div class="sidebar__item_dropdown-body" :class="item.active ? 'active' : ''">
                        <router-link
                            v-for="link in item.items.filter((x) => x.visible)"
                            :key="link.title"
                            :to="link.path"
                            :class="$route.name === link.name ? 'active' : ''"
                        >
                            {{ link.title }}
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="sidebar__item sidebar-collapse" @click="toggleSidebarCollapsed({ collapsed: !sidebarCollapsed, routeGroup: $route.meta.group })" aria-label="Toggle sidebar collapse">
                <svg width="24px" height="24px" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M13.4092 16.4199L10.3492 13.55C10.1935 13.4059 10.0692 13.2311 9.98425 13.0366C9.89929 12.8422 9.85547 12.6321 9.85547 12.4199C9.85547 12.2077 9.89929 11.9979 9.98425 11.8035C10.0692 11.609 10.1935 11.4342 10.3492 11.29L13.4092 8.41992" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7 21.4202H17C19.2091 21.4202 21 19.6293 21 17.4202V7.42017C21 5.21103 19.2091 3.42017 17 3.42017H7C4.79086 3.42017 3 5.21103 3 7.42017V17.4202C3 19.6293 4.79086 21.4202 7 21.4202Z" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                <p>Свернуть меню</p>
            </div>
        </div>
    </div>

    <div class="sidebar sidebar_mobile" id="mobile_sidebar" :class="mobileSidebar ? 'active' : ''">
        <div class="sidebar-links">
            <div v-for="item in sidebarItems.filter((x) => x.visible)" :key="item.name">
                <router-link
                    v-if="!item.dropdown"
                    class="sidebar__item"
                    :to="item.path"
                    :class="$route.name === item.name ? 'active' : ''"
                >
                    <div class="sidebar__item-rec"></div>
                    <img :src="require('@/assets/img/sidebar/' + item.icon)" alt="" />
                    {{ item.title }}
                </router-link>

                <div v-else class="sidebar__item_dropdown">
                    <div
                        class="sidebar__item sidebar__item_dropdown-header"
                        :class="isSidebarHeaderActive(item) ? 'active' : ''"
                        @click="dropdownController(item.name)"
                    >
                        <div class="sidebar__item-rec"></div>
                        <img :src="require('@/assets/img/sidebar/' + item.icon)" alt="" />
                        {{ item.title }}
                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1 3L7 9L13 3"
                                stroke="#2E343B"
                                stroke-width="1.2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <div class="sidebar__item_dropdown-body" :class="item.active ? 'active' : ''">
                        <router-link
                            v-for="link in item.items.filter((x) => x.visible)"
                            :key="link.title"
                            :to="link.path"
                            :class="$route.name === link.name ? 'active' : ''"
                        >
                            {{ link.title }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    data() {
        return {
            routePath: this.$route.path,
        };
    },

    props: {
        routeName: {
            type: String,
            default: "home",
        },
    },

    computed: {
        ...mapState({
            sidebarItems: (state) => state.sidebarItems,
            user_permissions: (state) => state.user_permissions,
            mobileSidebar: (state) => state.mobileSidebar,
            sidebarCollapsed: (state) => state.sidebarCollapsed,
        }),
    },

    methods: {
        ...mapActions({
            dropdownController: "dropdownController",
            toggleSidebarCollapsed: "toggleSidebarCollapsed",
        }),

        isSidebarHeaderActive(item) {
            if (!item.dropdown) {
                return this.$route.name === item.name;
            }

            return item.active || this.$route.meta.group === item.name;
        },
    },

    // mounted() {
    //     this.$store.dispatch("mobileSidebarController");
    // },

    watch: {
        $route(newValue) {
            const group = newValue.meta.group;
            
            if(this.mobileSidebar) {
                this.$store.dispatch("mobileSidebarController");
            }

            const elem = this.sidebarItems.find((x) => x.name === group);
            if (elem) {
                elem.active = true;
            }
        },
    },
};
</script>
